import { inject, Pipe, PipeTransform } from '@angular/core';
import { Client } from '@df/core/service/client';

@Pipe({
    name: 'aspectRatio',
    standalone: true
})
export class AspectRatioPipe implements PipeTransform {
    private client = inject(Client);

    transform(isLandscape: boolean, colSpan = 1, rowSpan = 1): string {
        if (isLandscape && rowSpan === 1 && colSpan > 1) {
            return ['100 / 64.97', '100 / 65.5', '100 / 66.3', '100 / 66.3'][this.client.sizeId];
        }

        return '3 / 4';
    }
}
